module.exports = __webpack_public_path__ + "static/20-c57027668f46e11d4e77a3ea4464d690.jpg";